import { v4 as uuidv4 } from 'uuid';
import { CustomFile } from '../../interfaces/custom_file.interface';
import { ModuleToEdit } from './module_to_edit.model';

export class SectionToEdit {
  courseSectionId: string;
  name: string;
  number?: number;
  attachments: Array<any>;
  isLocal: boolean;
  acceptClassFilesLimit: number;
  modules: Array<ModuleToEdit>;
  filesToUpload?: Array<CustomFile>;
  hidden: boolean;
  isDeletingRemoteAttachment: boolean;
  showPromotion: boolean;
  // FP courses only — the academic year (course_year) this section belongs to. Null for standard/flash courses.
  courseYearId?: string | null;

  constructor() {
    this.courseSectionId = uuidv4();
    this.name = '';
    this.attachments = [];
    this.isLocal = true;
    this.acceptClassFilesLimit = 10;
    this.filesToUpload = [];
    this.modules = [new ModuleToEdit()];
    this.hidden = false;
    this.isDeletingRemoteAttachment = false;
    this.showPromotion = false;
    this.courseYearId = null;
  }
}
